module.exports = __webpack_public_path__ + "img/partTwo-vedio.12368da2.png";